<template>
    <div ref="selectUsersButton" class="custom-select blur-focus" :class="[{ 'mousedown':  focus }, direction, size]">
        <custom-button 
            class="custom-button"
            :variation="variation" 
            :size="size" 
            :disabled="disabled || options.length === 0"
            @click="handleButtonClick" 
        >
            <slot></slot>
            <svg v-if="arrow" class="arrow-down" width="16" height="16" viewBox="0 0 512 512"><path d="M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"/></svg>
        </custom-button>
        <transition-group v-if="selectionType === 'buttons'" name="slide-users" class="options">
            <custom-button 
                v-for="option in computedOptions" 
                :key="option.value"
                variation="white" 
                size="medium" 
                @click="handleSelectOption(option)"
            >{{ option.label }}</custom-button>
        </transition-group>
        <custom-drawer
            v-else
            ref="customDrawer"
            v-model="selectedUserIds"
            :options="options"
            :favorites="favorites"
            @toggleFavorite="$emit('toggleFavorite', $event)"
            @optionUpdated="optionUpdated"
        ></custom-drawer>
    </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';
import CustomDrawer from '@/components/CustomDrawer.vue';

export default {
    name: 'custom-select',
    components: {
        CustomButton,
        CustomDrawer
    },
    props: {
        value: {
            type: [String, Array],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default() { return [] }
        },
        size: {
            type: String,
            default: 'medium'
        },
        variation: {
            type: String,
            default: 'primary'
        },
        direction: {
            type: String,
            default: 'down'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        arrow: {
            type: Boolean,
            default: false
        },
        favorites: {
            type: Boolean,
            default: false
        },
        // drawer | buttons
        selectionType: {
            type: String,
            default: 'drawer'
        }
    },
    data() {
        return {
            focus: false,
            selectedUserIds: this.value
        }
    },
    methods: {
        handleClickElement(targetElement) {
            const element = this.$refs.selectUsersButton;
            if(!element.contains(targetElement)) this.focus = false;
        },
        handleSelectOption(option) {
            this.$emit('input', option.value);
            if(!this.multiple) this.focus = false;
            else if(this.options.length === 1) this.focus = false;
        },
        handleButtonClick() {
            if(this.selectionType === 'buttons') this.focus = !this.focus;
            else this.$refs.customDrawer.openDrawer();
        },
        optionUpdated() {
            this.$emit('input', this.selectedUserIds);
        }
    },
    computed: {
        computedOptions: function() {
            if(!this.focus) return []
            return this.options
        }
    },
    mounted() {
        const vm = this;
        this.$root.$on('clickElement', vm.handleClickElement)
    },
    beforeDestroy() {
        const vm = this;
        this.$root.$off('clickElement', vm.handleClickElement);
    },
    watch: {
        value: function() {
            this.selectedUserIds = this.value;
        }
    }
}
</script>

<style lang="scss" scoped>

.custom-select {
    --button-height: 42px;
    position: relative;
    width: 100%;

    &.medium {
        --button-height: 42px;
    }
    &.large {
        --button-height: 50px;
    }

    &.down {
        .options {
            top: var(--button-height);
            flex-direction: column;
        }
    }
    &.up {
        .options {
            bottom: var(--button-height);
            flex-direction: column-reverse;
        }
    }

    .custom-button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;

        svg {
            // position: absolute;
            // left: 12px;
            // top: 50%;
            // translate: 0 -50%;
            path {
                fill: #2f343a;
            }
        }
    }

    .options {
        position: absolute;
        display: flex;
        gap: 4px;
        width: 100%;
        padding: 6px 10px;
        margin: -6px -10px;
        max-height: 240px;
        overflow-y: auto;
    }
}

.blur-focus {
    isolation: isolate;

    &:after {
        content: "";
        position: absolute;
        inset: -100vh;
        transition: .15s ease;
        pointer-events: none;
        z-index: -1;
    }
    &.enabled:focus,
    &.enabled:focus-within,
    &.mousedown {
        z-index: 100;
        &:after {
            -webkit-backdrop-filter: blur(.5px) brightness(80%);
            backdrop-filter: blur(.5px) brightness(80%);
            transition: 1s cubic-bezier(.15,.75,.2,1);
        }
    }
}

.slide-users-enter-active {
    --margin-top: -40px;
    animation: slideIn .3s ease forwards;
    z-index: -1;
}
.slide-users-leave-active {
    --margin-top: -40px;
    animation: slideOut .2s ease forwards;
    z-index: -1;
}

@keyframes slideIn {
    from {
        scale: 0.5;
        opacity: 0;
        margin-top: var(--margin-top);
    } to {
        scale: 1;
        opacity: 1;
        margin-top: 0;
    }
}
@keyframes slideOut {
    from {
        scale: 1;
        opacity: 1;
        margin-top: 0;
    } to {
        scale: 0.5;
        opacity: 0;
        margin-top: var(--margin-top);
    }
}

</style>